import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {

	/** @override */
	public getFirstDayOfWeek(): number {
		return 1; // Lundi
	}

}